import { ChangeDetectionStrategy, Component, ViewEncapsulation, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

@Component({
    selector: 'app-debug-modal',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    templateUrl: './debug-modal.component.html',
    imports: [
        MatDialogModule
    ]
})
export class DebugDialogComponent {
    protected readonly dialogRef = inject(MatDialogRef<DebugDialogComponent>);
    protected readonly data = inject<any>(MAT_DIALOG_DATA);

    Info: any | null = this.data ?? null;

    closeDialog() {
        this.dialogRef.close();
    }

}
